import { Toaster } from "react-hot-toast";
import { WagmiProvider } from "wagmi";
import { Rewards } from "./pages/rewards";
import { Farms } from "./pages/farms";
import { Charge } from "./pages/charge";
import { Vote } from "./pages/vote";
import { wagmiConfig } from "@/src/configs/web3Modal";
import { AirdropProvider, BalanceProvider, RebaseProvider, ThemeProvider } from "@/src/context";
import { MetricsProvider } from "@/src/context";
import {  BrowserRouter as Router,  Routes,  Route} from "react-router-dom";
import "@/src/configs/web3Modal";
import { Dashboard } from "./pages/dashboard";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { DaoVoteProvider } from "@/src/context";
import { DaoVote } from "./pages/daovote";
import { Airdrops } from "./pages/airdrops";

const queryClient = new QueryClient()

function App() {
  return (
    <ThemeProvider>
    <WagmiProvider config={wagmiConfig}>
       <QueryClientProvider client={queryClient}>
      <BalanceProvider>
        <RebaseProvider>
        <MetricsProvider>
            <DaoVoteProvider>
              <AirdropProvider>
        <Router>
          <Routes>
          <Route path="/" element={<Farms />} />
          <Route path="Harvest" element={<Farms />} />
          <Route path="Rewards" element={<Rewards />} />
          <Route path="charge" element={<Charge />} />
          <Route path="Vote" element={<Vote />} />
          <Route path="Daovote" element={<DaoVote />} />
          <Route path="Metrics" element={<Dashboard />} />
          <Route path="Airdrops" element={<Airdrops />} />
          </Routes>
        </Router>
        <Toaster
          position="top-center"
          toastOptions={{
            className: "!bg-card !text-foreground !border !border-border !shadow-glow",
          }}
        />
        </AirdropProvider>
        </DaoVoteProvider>
        </MetricsProvider>
        </RebaseProvider>
      </BalanceProvider>
      </QueryClientProvider>
    </WagmiProvider>
    </ThemeProvider>
  );
}

export default App;
